// extracted by mini-css-extract-plugin
export default {"like":"fTnJs","not-clickable":"_1acK5","notClickable":"_1acK5","likebutton":"LdkZm","likes":"_2YLmQ"};